import { defineEvent } from '../types/event';
export var PACK_MODE_PACKS_SELECT = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'pack_mode_selected_packs'
        }
    ]
});
